/** Published subject routes. No value imports: this table ships in the app shell. */
export const SUBJECT_PAGES = [
  {
    path: '/english',
    subject: 'english',
    id: 'english',
    label: 'Secondary English',
    hub: true,
  },
  {
    path: '/english/g3',
    subject: 'english',
    id: 'english-g3',
    label: 'O-Level / SEC English (G3)',
    hub: false,
  },
  {
    path: '/english/ip',
    subject: 'english',
    id: 'english-ip',
    label: 'IP English & Language Arts',
    hub: false,
  },
  {
    path: '/english/ib',
    subject: 'english',
    id: 'english-ib',
    label: 'IB English: MYP Language & Literature',
    hub: false,
  },
  {
    path: '/english/exam-format',
    subject: 'english',
    id: 'english-exam-format',
    label: 'English exam format',
    hub: false,
  },
  {
    path: '/chemistry',
    subject: 'chemistry',
    id: 'chemistry',
    label: 'Secondary Chemistry',
    hub: true,
  },
  {
    path: '/chemistry/pure-chemistry',
    subject: 'chemistry',
    id: 'pure-chemistry',
    label: 'Pure Chemistry',
    hub: false,
  },
  {
    path: '/chemistry/combined-science',
    subject: 'chemistry',
    id: 'combined-science',
    label: 'Combined Science (Chemistry)',
    hub: false,
  },
  {
    path: '/chemistry/syllabus',
    subject: 'chemistry',
    id: 'chemistry-syllabus',
    label: 'Chemistry syllabus',
    hub: false,
  },
] as const;

export type SubjectPageRoute = (typeof SUBJECT_PAGES)[number];
export type SubjectPagePath = SubjectPageRoute['path'];
export type SubjectPageId = SubjectPageRoute['id'];
export const SUBJECT_PAGE_PATHS = SUBJECT_PAGES.map(page => page.path);
export function isSubjectPagePath(value: unknown): value is SubjectPagePath {
  return (
    typeof value === 'string' && SUBJECT_PAGE_PATHS.some(path => path === value)
  );
}
